<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('warehouses')"
          :directory="[$t('warehouses'), $t('warehouse')]"
          :icon="'users'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openModal()"
          >
            {{ $t("add_warehouse") }}
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-warehouse-modal
      v-if="isWarehouseModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeModal"
    />
    <app-warehouse-item-modal
      v-if="isWarehouseModalActiveItem"
      :table-id="tableId"
      :warehouse="selectWarehouse"
      :selected-url="selectedUrlWr"
      @close-modal="closeModalItem"
    />
  
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="warehouse-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
 
   
   
  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { collection, urlGenerator, numberWithCurrencyMuseum } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner, WarehouseTypeList } from "@app/Mixins/Global/FilterMixins";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Warehouse",
  extends: CoreLibrary,
  mixins: [owner, WarehouseTypeList, DeleteMixin],
  data() {
    return {
      urlGenerator,
      numberWithCurrencyMuseum,
      isWarehouseModalActive: false,
      isWarehouseModalActiveItem: false,
      isContactModalActive: false,
      tableId: "warehouse-modal",
      contacttableId: "contact-modal",
      confirmationModalActive: false,
      isQuickViewModalActive: false,
      organizationModal: false,
      warehouseActivitiesModal: false,
      editedUrl: "",
      selectWarehouse: "",
      selectedUrlWr: "",
      viewAllDeal: false,
      viewAllFollower: false,
      isNoteModal: false,
      noteRowData: null,
      warehouseId: null,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      warehouseFundData: {},
      
      options: {
        name: this.$t("warehouse_table"),
        url: "crm/warehouses",
        showHeader: true,
        countView: true,
        columns: [
        
        {
          title: this.$t("fund-picture"),
          type: "custom-html",
          key: "profile_picture",
          modifier: (value, row) => {
            return value
              ? `<span class="img-list"><img src="${value.path}"/><div class="img-list-up"><img src="${value.path}"/></div></span>`
              : "-";
          },
        },
        
        {
          title: this.$t("warehouse_name"),
          type: "custom-html",
		  key: "name",
          modifier: (value, row) => {
			  return '<a href="/crm/warehouses/'+row.id+'/edit">'+value+'</a>';
          },
        },
        {
          title: this.$t("price"),
          type: "custom-html",
		  key: "price",
          modifier: (value, row) => {
			  return numberWithCurrencyMuseum(value);
          },
        },
          {
            title: this.$t("lead_group"),
            type: "custom-html",
            key: "warehouse_type",
            modifier: (value, row) => {
              return value 
                ? `<span class="badge badge badge-primary badge-pill">${value.name
                }</span>`
                : "-";
            },
          },
          {
            title: this.$t("warehouse_pre"),
            type: "custom-html",
            key: "pre",
            modifier: (value, row) => {
              return '<span>' + value.qty + ' ' + this.$t('qty') + ' (' + numberWithCurrencyMuseum(value.price) + ')';
            },
          },
          {
            title: this.$t("warehouse_rase"),
            type: "custom-html",
            key: "rase",
            modifier: (value, row) => {
              return '<span>' + value.qty + ' ' + this.$t('qty') + ' (' + numberWithCurrencyMuseum(value.price) + ')';
            },
          },
          {
            title: this.$t("warehouse_ord"),
            type: "custom-html",
            key: "ord",
            modifier: (value, row) => {
              return '<span>' + value.qty + ' ' + this.$t('qty') + ' (' + numberWithCurrencyMuseum(value.price) + ')';
            },
          },
          {
            title: this.$t("warehouse_sum"),
            type: "custom-html",
            key: "sum",
            modifier: (value, row) => {
              return '<span>' + value + ' ' + this.$t('qty') + ' (' + numberWithCurrencyMuseum(value.price) + ')';
            },
          },
        
	    
      
        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
        filters: [
       
          {
            title: this.$t("lead_group"),
            type: "radio",
            key: "warehouse_type",
            option: [],
          },
         
			
		
         
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 50,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          /*{
            title: this.$t("quick_view"),
            icon: "zap",
            type: "modal",
            component: "app-warehouse-quick-view",
            modalId: "quickViewModal",
            url: "",
          },*/
          {
            title: this.$t("edit_more"),
            icon: "external-link",
            type: "page-redirect",
            modalId: "renewe-modal",
            url: "",
          },
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-warehouse-modal",
            modalId: "warehouse-modal",
            url: "",
          },
          {
            title: this.$t("add_oper_item"),
            icon: "edit",
            type: "modal",
            component: "app-warehouse-item-modal",
            modalId: "warehouse-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "warehouse-delete-modal",
            url: "",
          },
     
        ],
      },
    };
  },
  methods: {
	  
	
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `crm/warehouses/${rowData.id}`;
        this.isWarehouseModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/warehouses/${rowData.id}`;
        this.confirmationModalActive = true;
      } else if (actionObj.title == this.$t("delete_fund")) {
        this.deleteFund(rowData.id);
      } else if (actionObj.title == this.$t("edit_more")) {
        //this.selectedUrl = `crm/renewes/${rowData.id}`;
        //this.isReneweModalActive = true;
        window.location = `/crm/warehouses/${rowData.id}/edit`;
      } else if (actionObj.title == this.$t("add_oper_item")) {
        this.selectWarehouse = rowData.id;
        this.isWarehouseModalActiveItem = true;
      }
    },
    openModal() {
      this.isWarehouseModalActive = true;
    },


    closeModal() {
      this.isWarehouseModalActive = false;
      this.selectedUrl = "";
      $("#warehouse-modal").modal("hide");
    },
    closeModalItem() {
      this.isWarehouseModalActiveItem = false;
      this.selectWarehouse = "";
      $("#warehouse-modal").modal("hide");
    },

  
    deleteFund(id){

      
      this.warehouseFundData.id = id;
      this.warehouseFundData.change = 1;
      this.warehouseFundData.fund_id = null;
      

      this.axiosPatch({
        url: '/crm/warehouses/' + id,
        data: this.warehouseFundData,
      }).then((response) => {
        this.$toastr.s(response.data.message);
            this.errors = {}
            this.$emit('update-request');
            this.$hub.$emit('reload-' + this.tableId);

      }).catch(({ response }) => {

      }).finally(() => {


      });


    },

 
   

  },
  computed: {

  },
  mounted() {
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
